import DynamicForm from "components/DynamicForm";
import { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearSelectedDataKey, setRadioFields, setToggleFields } from "redux/formDisplay";
import "./index.scss";
import LoadingSpinner from "lib/LoadingSpinner";

const Emandate = (props) => {
  const {
    formFields,
    setSelectedData,
    selectedData,
    formErr,
    setFormErr,
    clearFieldError,
    className,
  } = props;

  let toggleId;
  let dependentField = [];
  let radioId;
  let radioDependentField = [];
  const dispatch = useDispatch();

  useEffect(() => {
    let clearObj = [
      "mandate_type_category_code",
      "physical_nach_first_collection_date",
      "first_collection_date",
      "final_collection_date",
      "due_date",
      "instructed_agent_code",
      "debtor_account_type",
      "debtor_account_id",
      "instructed_agent_id_type",
      "instructed_agent_id",
      "occurance_frequency_type",
      "collection_amount_type"
    ];
    clearObj.map((fields) => {
      if(selectedData.hasOwnProperty(fields)) {
        dispatch(clearSelectedDataKey({key: fields}))
      }
    })
  }, [selectedData?.authentication_mode]);

  useEffect(() => {
    let clearObj = [
      "occurance_frequency_type",
      "collection_amount_type",
      "due_date",
      "physical_nach_first_collection_date",
      "first_collection_date",
      "final_collection_date",
      "instructed_agent_code",
      "debtor_account_type",
      "debtor_account_id",
      "instructed_agent_id_type",
      "instructed_agent_id"
    ];
    clearObj.map((fields) => {
      if(selectedData.hasOwnProperty(fields)) {
        dispatch(clearSelectedDataKey({key: fields}))
      }
    })
  }, [selectedData?.mandate_type_category_code]);

  useEffect(() => {
    let clearObj = [
      "collection_amount_type",
      "due_date",
      "physical_nach_first_collection_date",
      "first_collection_date",
      "final_collection_date",
      "instructed_agent_code",
      "debtor_account_type",
      "debtor_account_id",
      "instructed_agent_id_type",
      "instructed_agent_id"
    ];
    clearObj.map((fields) => {
      if(selectedData.hasOwnProperty(fields)) {
        dispatch(clearSelectedDataKey({key: fields}))
      }
    })
  }, [selectedData?.occurance_frequency_type]);

  useEffect(() => {
    if (formFields) {
      let data = formFields[0];
      if (data.type === "radio") {
        radioId = data.name;
      }
      formFields.map((item) => {
        if (item.type === "toggle") {
          toggleId = item.name;
        }
        if (String(item?.show).includes(String(toggleId))) {
          dependentField.push(item.name);
        }
        if (String(item?.show).includes(String(radioId))) {
          radioDependentField.push(item.name);
        }
      });
    }
    if (toggleId) {
      dispatch(setToggleFields({ key: toggleId, value: dependentField }));
    }
    if (radioId && radioDependentField.length > 0) {
      dispatch(setRadioFields({ key: radioId, value: radioDependentField }));
    }
  }, [formFields]);

  if (!formFields) {
    return (
      <div className="loadingForMandate">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div
      className={`mt-3 bg-theme-grey-2 border-theme-grey rounded-3 ${className}`}
    >
      <div
        className={`row position-relative p-2 p-lg-3 gy-2 pb-4 ${
          className ? "gy-lg-4" : "gy-lg-1"
        }`}
      >
        {formFields &&
          formFields?.map((item, i) => {
            return (
              <Fragment key={i}>
                <DynamicForm
                  formErr={formErr}
                  clearFieldError={clearFieldError}
                  formFields={item}
                  selectedData={selectedData}
                  setFormErr={setFormErr}
                  setSelectedData={setSelectedData}
                />
              </Fragment>
            );
          })}
      </div>
    </div>
  );
};
export default Emandate;
